import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import OAuthCallback from './components/OAuthCallback';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AppDataProvider from './components/AppDataProvider';
import Routes from './Routes';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Topbar from './components/Topbar';
import Login from './components/Login';
import { TablesAIQueryProvider } from './components/tables/TablesAIQueryContext';

const ProtectedLayout = ({ children }) => {
  const { isAuthenticating, isAuthenticated, currentUser, logout } = useAuth();

  if (isAuthenticating) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-xl font-medium text-gray-700 dark:text-gray-200">Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <Topbar currentUser={currentUser} logout={logout} />
      <div className="min-h-0 flex-1">
        {isAuthenticated ? children : <Login />}
      </div>
    </div>
  );
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <TablesAIQueryProvider>
            <AppDataProvider>
              {/* /auth/callback renders OUTSIDE the gate: behind it, an unauthenticated
                  visitor only ever sees <Login />, and the code would never be exchanged. */}
              <RouterRoutes>
                <Route path="/auth/callback" element={<OAuthCallback />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedLayout>
                      <Routes />
                    </ProtectedLayout>
                  }
                />
              </RouterRoutes>
            </AppDataProvider>
          </TablesAIQueryProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;